import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useLazySetInstallationsQuery } from "../../../Store/Builder/techsbook.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";

const useSetInstallationsApi = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [installationsApi] = useLazySetInstallationsQuery();

  const send = (data) => {
    dispatch(setLoader(true));
    installationsApi(data)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        showToast(res?.message ?? "Success", "success");
        navigate("/register-providers", {
          state: { ...location?.state, ...data },
        });
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    send,
  };
};

export default useSetInstallationsApi;
